module.exports = __webpack_public_path__ + "img/loading.199f9142.png";